import { client } from "@/config/client"

export interface UpdateUser {
  lives: number
  country: string
  gifted: boolean
}

export function update(id: number, data: UpdateUser) {
  return client.put(`/v1/users/${id}`, data)
}
